/**
 *
 * @module accessTokenUpdater
 *
 */

/**
 *
 * @class AccessTokenUpdater
 *
 */
export default class AccessTokenUpdater {

    /**
     *
     * @access private
     * @param {Boolean} [force=false] - Forces a refresh regardless of the token's current expiration
     * @desc Refreshes the access token if it is about to expire
     * @returns {Promise<Void>}
     *
     */
    refreshAccessToken(force = false) { // eslint-disable-line

        return new Promise((resolve, reject) => {
            return reject(new Error('not-implemented'));
        });

    }

}



// WEBPACK FOOTER //
// ./src/token/accessTokenUpdater.js